export const AP_ROGUE_SECTION_EVENT = 'canvas-agent:rogue-ap:section';
export const AP_PACKET_CAPTURE_SECTION_EVENT =
	'canvas-agent:packet-capture:section';
export const AP_INTERFACE_SECTION_EVENT = 'canvas-agent:ap-interface:section';
export const AP_ALARMS_SECTION_EVENT = 'canvas-agent:ap-alarms:section';
export const AP_RADIO_SETTINGS_SECTION_EVENT =
	'canvas-agent:ap-radio-settings:section';
